import { Component, Input, OnInit } from '@angular/core';

export interface MenuAction {
	label: string;
	action: () => void;
	icon?: string;
	disabled?: boolean;
}

@Component({
	selector: 'ws-popup-menu',
	templateUrl: './popup-menu.component.html',
	styleUrls: ['./popup-menu.component.scss'],
})
export class PopupMenuComponent implements OnInit {
	@Input() actions: MenuAction[] = [];
	@Input() icon: string = 'more_vert';
	@Input() styleClass!: string;

	// Because of some issue in angular-material we need to move the actions to an internal property
	menuActions: MenuAction[] = [];

	ngOnInit() {
		this.menuActions = this.actions;
	}
}
